import { ContentTypeCodenames } from "services/cms/models/contentTypeCodenames";
import type { Timeline } from "services/cms/models/timeline";
import type { IContentItem } from "services/content-manager/models";

export interface ResolvedTimelineItem {
    date: string;
    id: string;
    title: string;
}

export interface ResolvedTimeline {
    codename: string;
    timeline: ResolvedTimelineItem[];
    type: ContentTypeCodenames.AboutUsTimeline;
}

const timelineResolver = (data: Timeline): ResolvedTimeline => {
    const timeline = (data.elements as unknown as any).timeline.linkedItems
        .map((linkedItem: IContentItem) => {
            const {
                elements: { date: dateElement, title: titleElement },
                system: { id },
            } = linkedItem;

            return {
                date: dateElement.value,
                id,
                title: titleElement.value,
            };
        })
        .sort((a: ResolvedTimelineItem, b: ResolvedTimelineItem) => {
            const dateA = new Date(a.date);
            const dateB = new Date(b.date);

            return dateA.getTime() - dateB.getTime();
        });

    const codename = data.system.codename;

    return {
        codename,
        timeline,
        type: ContentTypeCodenames.AboutUsTimeline,
    };
};

export default timelineResolver;
